import {Loader} from '@progress/kendo-react-indicators';
import React, {Fragment} from 'react';
import './RoleTable.scss';
import CustomButton from '../../stateless/customButton/CustomButton';

interface ITableProps {
    userId: string;
    values: any[];
    columns: any;
    type: string;
    height: string;
    modifyAppUserRole: (role: any) => void;
    columnHeader: string[],
}


function RoleTable(props: ITableProps) {

    return (
        <div className='table-wrapper'>

            <table className='table'>
                <thead>
                <tr>
                    {props.columnHeader.map((header: string) => (
                        <th>{header}</th>
                    ))}
                </tr>
                </thead>
                {props.columns && props.values.length !== null ? (
                    <tbody>
                    {props.values.map((row: any) => (
                        <Fragment key={row.id}>
                            <tr>
                                <td>{row.name}</td>
                                <td>
                                    <CustomButton
                                        fillMode='solid'
                                        icon=''
                                        themeColor={props.type === 'delete' ? 'warning' : 'primary'}
                                        onClick={() => props.modifyAppUserRole(row)}
                                    >
                                        {props.type === 'delete' ? 'Remove' : 'Add'}
                                    </CustomButton>
                                </td>
                            </tr>
                        </Fragment>
                    ))}
                    </tbody>
                ) : (
                    <div style={{width: '90vw'}}>
                        {/* if loading show spinner */}
                        <Loader type='converging-spinner'/>
                    </div>
                )}
            </table>
        </div>
    );
}

export default RoleTable;
